import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup, Input, Button, Badge, Container, FormFeedback } from 'reactstrap';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import c from '../../constants/Colors';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { getTransportista } from '../../../src/store/sagas/transportistaApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";




export class Transportistas extends Component {
  static displayName = Transportistas.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      isActiveModal: false,
      isActiveModal2: false,

      loading: false,
      showModal: false,
      alertTitulo: "",
      alertMensaje: "",
      showAlert: false,
      contactos: [],
      recojos: [],
      transportes: [],
      alertas: [],

      contacto: {},
      recojo: {},
      transporte: {},
      showModal2: false,
      recojoOtro: false,

      datosTotal: { total: 0, acumulado: 0, total: 0 },
      datosLocal: {},
      localId: 0,
      pedidoId: 0,
      showOtros: false,
      errorDni: null,
      errorCelular: null
    };
  }
  toggleModal = () => {
    this.setState(prevState => ({
      isActiveModal: !prevState.isActiveModal,
    }));
  }
  toggleModal2 = () => {
    this.setState(prevState => ({
      isActiveModal2: !prevState.isActiveModal2,
    }));
  }

  // IrResumenPedido = () => {
  //   this.props.history.push({
  //     pathname: 'resumen-pedido',
  //   });
  // }


  IrMedioPago = () => {


    let rpta = true;
    let errorDni = null;
    let errorCelular = null;
    let con = this.state.contacto;
    if (this.state.recojoOtro) {
      if (con.dni.length < 8) {
        errorDni = 'Solo números de 8 dígitos';
        rpta = false;
      }

      if (con.telef.length < 7) {
        errorCelular = 'Solo números mínimo 7 y máximo 9 dígitos';
        rpta = false;
      }

      con.nombre = con.nom + " " + con.ape;
      this.setState({
        contacto: con,
        errorDni,
        errorCelular
      });

    }

    if (rpta) {
      this.props.history.push({
        pathname: 'medio-pago',
        state: {
          datosTotal: this.state.datosTotal,
          datosLocal: this.state.datosLocal,
          localId: this.state.localId,
          transportista: {
            contacto: this.state.contacto,
            recojo: this.state.recojo,
            transporte: this.state.transporte
          }
        }
      });
    }
  }


  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }

  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      let _datosTotal = state.datosTotal;
      let _datosLocal = state.datosLocal;
      let _recojoOtro = state.recojoOtro == undefined ? false : state.recojoOtro;
      console.log("Transportista====>", state.datosLocal);
      this.setState({
        datosTotal: _datosTotal,
        datosLocal: _datosLocal,
        pedidoId: state.pedidoId,
        localId: state.localId,
        recojoOtro: _recojoOtro
      });
    }
  }

  load = (carritoProdctos, setcarritoProdctos, localEnvio) => {

    console.log("load localEnvio==>", localEnvio);


    let storage = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true });
    getTransportista(
      storage.dealer.codcliente,
      storage.dealer.correoElectronico,
      storage.linea.vkorg,
      storage.asociado.poblacion,
      localEnvio)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            contactos: result.dto.transportista.contactos,
            recojos: result.dto.transportista.recojos,
            transportes: result.dto.transportista.transportes,

            contacto: result.dto.transportista.contacto ?? {},
            recojo: result.dto.transportista.recojo ?? {},
            transporte: result.dto.transportista.transporte ?? {},

            showOtros: storage.asociado.region != "LIMA"
          });
          console.log("result.dto.transportista.transporte===>", result.dto.transportista.transporte);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
        this.setState({ loading: false });
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Transportista", error.message ?? null);
        });
      });


  }

  setTransporte = (item) => {
    console.log("setTransporte==>", item);
    this.setState({ transporte: item });
  }
  setRecojo = (item) => {
    console.log("setRecojo==>", item);
    this.setState({ recojo: item });
  }
  setContacto = (item) => {
    console.log("setContacto==>", item);
    this.setState({
      contacto: item,
      recojoOtro: false,
    });
  }
  setOtro = () => {
    this.setState({
      recojoOtro: true,
      contacto: {
        dni: "",
        nom: "",
        ape: "",
        telef: ""
      },
      errorDni: null
    });
  }


  handledataDni = (value) => {
    let con = this.state.contacto;
    let de = /[^0-9]/g;
    value = value.replace(de, "");
    con.dni = value;
    if (con.dni != "" && con.nom != "" && con.ape != "" && con.telef != "")
      con.codap = "-1";
    else
      con.codap = '';
    this.setState({
      contacto: con,
      errorDni: null
    });

  };

  handledataNombre = (value) => {
    let con = this.state.contacto;
    con.nom = value;
    if (con.dni != "" && con.nom != "" && con.ape != "" && con.telef != "")
      con.codap = "-1"; else
      con.codap = '';
    this.setState({
      contacto: con
    });


  };

  handledataApellidos = (value) => {
    let con = this.state.contacto;
    con.ape = value;
    if (con.dni != "" && con.nom != "" && con.ape != "" && con.telef != "")
      con.codap = "-1"; else
      con.codap = '';
    this.setState({
      contacto: con
    });

  };

  handledataTelefono = (value) => {
    let con = this.state.contacto;
    let de = /[^0-9]/g;
    value = value.replace(de, "");

    con.telef = value;
    if (con.dni != "" && con.nom != "" && con.ape != "" && con.telef != "")
      con.codap = "-1"; else
      con.codap = '';
    this.setState({
      contacto: con,
      errorCelular: null
    });

  };

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      const auth = this.context;
      this.checkParams();
      console.log("componentDidMount==>", auth.localEnvio);
      this.load(auth.carritoProdctos, auth.setcarritoProdctos, auth.localEnvio);
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { errorCelular, errorDni, showOtros, recojos, loading, transportes, showModal, transporte, recojoOtro, contacto, contactos, recojo, datosTotal, datosLocal, alertas } = this.state;
    const auth = this.context;

    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-envio" fill='#fff' />Envío</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li><Link to='/carrito/carrito'>Carrito de compras</Link></li>
              <li><Link to='/carrito/Ofertas'>Ofertas</Link></li>
              <li><Link to='/carrito/envio'>Envío</Link></li>
              <li><Link to='/transportistas'>Transportista</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="pt-5 pb-float">
          <h6 className="title white mobile">
            <Link to={{ pathname: '/carrito/envio' }} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>
            <SvgAssets icon="icon-envio" fill="#fff" />Transportista
          </h6>
          <div className='content_container_transport'>
            <div className="card container_1080">
              <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
              {(transporte.bloqueo == "1") ?
                <button className='btn btn-outline-link disabled'
                  disabled={true}>
                  <SvgAssets icon="icon-envio" fill="#316ACD" />
                  <span className='paragraph-1 desktop_parrafo1' style={{ textDecoration: 'underline' }}>{(transporte.name1) ? transporte.name1 : "Seleccione transportista"} </span>
                </button>
                :
                <button className='btn btn-outline-link'
                  onClick={() => this.toggleModal()}>
                  <SvgAssets icon="icon-envio" fill="#316ACD" />
                  <span className='paragraph-1 desktop_parrafo1' style={{ textDecoration: 'underline' }}>{(transporte.name1) ? transporte.name1 : "Seleccione transportista"} </span>
                </button>}
              <h6 className='title-1'>
                ¿En dónde se entregará?
              </h6>
              {recojos.map((item, index) => {
                return (
                  (item.enable == "0") ?
                    <div key={"recojo_" + index} className="card_product_horizontal card_envio height_40 disabled">
                      <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                        <div className="custom-control custom-radio">
                          {(item.codrec == recojo.codrec) ?
                            <input checked="checked" type="radio" id={`recojo_c_${index}`} name="radio_recojo" className="custom-control-input" disabled />
                            :
                            <input type="radio" id={`recojo_c_${index}`} name="radio_recojo" className="custom-control-input" disabled />
                          }
                          <label className="custom-control-label" htmlFor={`recojo_c_${index}`}></label>
                        </div>
                      </div>
                      <div className="cphTextCenter">
                        <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>{item.desrec}</span>
                      </div>
                    </div> :
                    <div key={"recojo_" + index} className="card_product_horizontal card_envio height_40">
                      <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                        <div className="custom-control custom-radio">
                          {(item.codrec == recojo.codrec) ?
                            <input onChange={() => this.setRecojo(item)} checked="checked" type="radio" id={`recojo_c_${index}`} name="radio_recojo" className="custom-control-input" />
                            :
                            <input onChange={() => this.setRecojo(item)} type="radio" id={`recojo_c_${index}`} name="radio_recojo" className="custom-control-input" />
                          }
                          <label className="custom-control-label" htmlFor={`recojo_c_${index}`}></label>
                        </div>
                      </div>
                      <div className="cphTextCenter">
                        <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>{item.desrec}</span>
                      </div>
                    </div>
                )
              })}
              {/* <div className="card_product_horizontal card_envio height_40">
                <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                  <div className="custom-control custom-radio">
                    <input type="radio" id={`radio1`} name="radio_ln" className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={`radio1`}></label>
                  </div>
                </div>
                <div className="cphTextCenter">
                  <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>Agencia principal</span>
                </div>
              </div>
              <div className="card_product_horizontal card_envio height_40">
                <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                  <div className="custom-control custom-radio">
                    <input type="radio" id={`radio2`} name="radio_ln" className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={`radio2`}></label>
                  </div>
                </div>
                <div className="cphTextCenter">
                  <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>A domicilio</span>
                </div>
              </div>
              <div className="card_product_horizontal card_envio height_40 disabled">
                <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                  <div className="custom-control custom-radio">
                    <input type="radio" id={`radio3`} name="radio_ln" className="custom-control-input" disabled
                    />
                    <label className="custom-control-label" htmlFor={`radio3`}></label>
                  </div>
                </div>
                <div className="cphTextCenter">
                  <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>Almacén Callao</span>
                </div>
              </div> */}
            </div>


            <div className="card container_1080" style={{ marginBottom: '60px' }}>
              <h6 className='title-1 mt-0'>
                ¿Quién recibirá el pedido?
              </h6>
              <button className='btn btn-outline-link' style={{ marginBottom: '20px' }} onClick={() => this.toggleModal2()}>
                <SvgAssets icon="icon-user" fill={c.azulClaro} style={{ width: '20px' }} />
                <span className='paragraph-1 desktop_parrafo1' style={{ textDecoration: 'underline' }}>
                  {(recojoOtro) ? "Seleccione un encargado" : (contacto.nombre) ? contacto.nombre : "Seleccione un encargado"}
                </span>
              </button>

              <form className='collapse_filter_person'>
                {(showOtros) ?
                  <div className="card_product_horizontal card_envio height_40">
                    <div className="cphCounterInput check" style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                      <div className="custom-control custom-radio">
                        {(recojoOtro) ?
                          <input onChange={() => this.setOtro()} checked="checked" type="radio" id={`radio4`} name="radio_ln" className="custom-control-input" />
                          :
                          <input onChange={() => this.setOtro()} type="radio" id={`radio4`} name="radio_ln" className="custom-control-input" />
                        }
                        <label className="custom-control-label" htmlFor={`radio4`}></label>
                      </div>
                    </div>
                    <div className="cphTextCenter">
                      <span className="address bold" style={{ color: 'rgb(49, 106, 205)' }}>Otra persona</span>
                    </div>
                  </div> : null}

                {(recojoOtro) ?
                  <div className='content_campo_perfil'>
                    <div className="campo-perfil">
                      <div className="icon" style={{ backgroundColor: c.MoradoOscuro }}>
                        <SvgAssets icon="icon-cod-cli" fill="#fff" />
                      </div>
                      <div className="text">
                        <span className="paragraph-2" style={{ color: c.grisMedio }}>DNI</span>
                        <input
                          maxLength={8}
                          name="dni"
                          value={contacto.dni}
                          onChange={(dni) => this.handledataDni(dni.target.value)}
                          onKeyup={(dni) => this.handledataDni(dni.target.value)}
                          type="text" style={{ color: c.azulClaro }} />
                        {
                          errorDni ? <FormFeedback>{errorDni}</FormFeedback> : null
                        }
                      </div>
                    </div>
                    <div className="campo-perfil">
                      <div className="icon" style={{ backgroundColor: c.naranja }}>
                        <SvgAssets icon="icon-user" fill="#fff" />
                      </div>
                      <div className="text">
                        <span className="paragraph-2" style={{ color: c.grisMedio }}>Nombres</span>
                        <input
                          maxLength={20}
                          name="nom"
                          value={contacto.nom}
                          onChange={(nom) => this.handledataNombre(nom.target.value)}
                          onKeyup={(nom) => this.handledataNombre(nom.target.value)}
                          type="text" style={{ color: c.azulClaro }} />
                      </div>
                    </div>
                    <div className="campo-perfil">
                      <div className="icon" style={{ backgroundColor: c.MoradoOscuro }}>
                        <SvgAssets icon="icon-user" fill="#fff" />
                      </div>
                      <div className="text">
                        <span className="paragraph-2" style={{ color: c.grisMedio }}>Apellidos</span>
                        <input
                          name="ape"
                          maxLength={30}
                          value={contacto.ape}
                          onChange={(ape) => this.handledataApellidos(ape.target.value)}
                          onKeyup={(ape) => this.handledataApellidos(ape.target.value)}
                          type="text" style={{ color: c.azulClaro }} />
                      </div>
                    </div>
                    <div className="campo-perfil">
                      <div className="icon" style={{ backgroundColor: c.naranja }}>
                        <SvgAssets icon="icon-cod-cli" fill="#fff" />
                      </div>
                      <div className="text">
                        <span className="paragraph-2" style={{ color: c.grisMedio }}>N° de Teléfono</span>
                        <input
                          name="telef"
                          maxLength={9}
                          value={contacto.telef}
                          onChange={(telef) => this.handledataTelefono(telef.target.value)}
                          onKeyup={(telef) => this.handledataTelefono(telef.target.value)}
                          type="text" style={{ color: c.azulClaro }} />
                        {
                          errorCelular ? <FormFeedback>{errorCelular}</FormFeedback> : null
                        }
                      </div>
                    </div>
                  </div> : null}
              </form>
            </div>
          </div>
        </Container>
        <div className="float_section">
          <SvgAssets icon="curve-top" className="curve" fill={c.azul} />
          {/* <p className="total-price">TOTAL  (30 PRODUCTOS):<span> S/ 817.00</span></p> */}
          <p className="total-price">TOTAL: <span>{datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
          </p>

          {(!contacto.codap || !recojo.desrec || !transporte.name1) ?
            <button
              className={`btn-block disabled`}
              disabled={true}
              onClick={() => this.IrMedioPago()}
            >
              siguiente
            </button> :
            <button
              className={`btn-block`}
              onClick={() => this.IrMedioPago()}
            >
              siguiente
            </button>}
        </div>

        <Modal className='modal-select-transportista' centered backdrop="static" isOpen={this.state.isActiveModal} toggle={() => this.toggleModal()}>
          <ModalHeader>
            <button className="btn-icon modal-close" onClick={() => this.toggleModal()}>
              <SvgAssets icon="icon-close" fill={'#fffff'} /></button>
            <h6>Transportistas</h6>
          </ModalHeader>
          <ModalBody>
            <div className='content_scroll'>
              {transportes.map((item, index) => {
                return (
                  <div key={"transporte_" + index} className="card_product_horizontal card_envio height_40">
                    <div className="cphCounterInput check">
                      <div className="custom-control custom-radio">
                        {(item.lifnr == transporte.lifnr) ?
                          <input checked="checked" type="radio" onChange={() => this.setTransporte(item)} id={`tra_${index}`} name="radio_transporte" className="custom-control-input" />
                          :
                          <input type="radio" onChange={() => this.setTransporte(item)} id={`tra_${index}`} name="radio_transporte" className="custom-control-input" />
                        }
                        <label className="custom-control-label" htmlFor={`tra_${index}`}></label>
                      </div>
                    </div>
                    <div className="cphTextCenter">
                      <span className="address">{item.name1}</span>
                    </div>
                  </div>
                )
              })}
            </div>
            {/* <div className="card_product_horizontal card_envio height_40">
              <div className="cphCounterInput check">
                <div className="custom-control custom-radio">
                  <input type="radio" id={`radio5`} name="radio_ln" className="custom-control-input"
                  />
                  <label className="custom-control-label" htmlFor={`radio5`}></label>
                </div>
              </div>
              <div className="cphTextCenter">
                <span className="address">TRANSPORTE MARVISUR</span>
              </div>
            </div>

            <div className="card_product_horizontal card_envio height_40">
              <div className="cphCounterInput check">
                <div className="custom-control custom-radio">
                  <input type="radio" id={`radio6`} name="radio_ln" className="custom-control-input"
                  />
                  <label className="custom-control-label" htmlFor={`radio6`}></label>
                </div>
              </div>
              <div className="cphTextCenter">
                <span className="address">TRANSPORTE NUEVO ORIENTE</span>
              </div>
            </div> */}
            {(transporte.lifnr) ?
              <button onClick={() => this.toggleModal()} className='btn-block' style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                Aceptar
              </button>
              :
              <button disabled={true} className='btn-block disabled' style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                Aceptar
              </button>
            }
          </ModalBody>
        </Modal>


        <Modal className='modal-select-transportista' centered backdrop="static" isOpen={this.state.isActiveModal2} toggle={() => this.toggleModal2()}>
          <ModalHeader>
            <button className="btn-icon modal-close" onClick={() => this.toggleModal2()}>
              <SvgAssets icon="icon-close" fill={'#fffff'} /></button>
            <h6>Encargados</h6>
          </ModalHeader>
          <ModalBody>
            <div className='content_scroll'>
              {contactos.map((item, index) => {
                console.log(contacto);
                return (
                  <div key={"contacto_" + index} className="card_product_horizontal card_envio height_40">
                    <div className="cphCounterInput check">
                      <div className="custom-control custom-radio">
                        {(item.codap == contacto.codap) ?
                          <input onChange={() => this.setContacto(item)} checked="checked" type="radio" id={`contacto_c_${index}`} name="radio_cont" className="custom-control-input" />
                          :
                          <input onChange={() => this.setContacto(item)} type="radio" id={`contacto_c_${index}`} name="radio_cont" className="custom-control-input" />
                        }
                        <label className="custom-control-label" htmlFor={`contacto_c_${index}`}></label>
                      </div>
                    </div>
                    <div className="cphTextCenter">
                      <span className="address">{item.nombre}</span>
                    </div>
                  </div>
                )
              })}
            </div>
            {(contacto.codap && contacto.codap != '-1') ?
              <button onClick={() => this.toggleModal2()} className='btn-block' style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                Aceptar
              </button> :
              <button disabled={true} className='btn-block disabled' style={{ backgroundColor: 'rgb(45, 185, 151)' }}>
                Aceptar
              </button>
            }
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
